import React, { useEffect, useState } from 'react';
import { AutoComplete } from "@progress/kendo-react-dropdowns";

const App = (props: any) => {
    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        if (props?.value && props?.data?.length && !props?.selectedValue?.streetName) {
            setIsOpened(true);
        } else {
            setIsOpened(false);
        }
    }, [props?.data, props?.selectedValue, props?.value]);

    return (
        <div>
            <AutoComplete
                data={props?.data}
                textField={props?.textField}
                value={props?.value}
                onChange={props?.onChange}
                placeholder={props?.placeholder}
                style={{ width: '300px' }}
                loading={props?.loading}
                name={props?.name}
                onBlur={props?.onBlur}
                itemRender={props?.itemRender}
                className={props?.className}
                opened={isOpened}
                onClose={props?.onClose}
                onFocus={props?.onFocus}
                tabIndex={props?.tabIndex}
            />
        </div>
    );
};

export default App;